// Static config for category pages (deals/blogs come from backend)

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/concerttickets", label: "Concerten" },
  { to: "/festivaltickets", label: "Festivals" },
  { to: "/vliegtickets", label: "Vliegtickets" },
  { to: "/attractietickets", label: "Attracties" },
  { to: "/blog", label: "Blog" },
];

export const CATEGORIES = {
  concerttickets: {
    key: "concert",
    eyebrow: "Concerttickets",
    title: "Goedkope Concerttickets – Bespaar Nu!",
    subtitle:
      "Vind tickets voor de beste concerten in Nederland en Belgie. Van Armin van Buuren tot Coldplay.",
    image:
      "https://images.pexels.com/photos/761543/pexels-photo-761543.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tableCols: ["Artiest", "Locatie", "Datum", "Prijs", "Aanbieder", ""],
    faqs: [
      {
        q: "Hoe koop ik veilig tickets via Tixter.nl?",
        a: "Alle tickets op Tixter.nl worden aangeboden door betrouwbare partners zoals Ticketmaster, Eventim en Tix.nl. Je wordt doorverwezen naar hun officiele websites, waar je veilig kunt betalen.",
      },
      {
        q: "Kan ik tickets annuleren?",
        a: "De annuleringsvoorwaarden zijn afhankelijk van de aanbieder. Raadpleeg altijd de voorwaarden op de website van de ticketverkoper.",
      },
      {
        q: "Hoe snel ontvang ik mijn tickets?",
        a: "Meestal ontvang je je tickets direct na betaling per e-mail. Soms duurt het tot 24 uur.",
      },
    ],
  },
  festivaltickets: {
    key: "festival",
    eyebrow: "Festivaltickets",
    title: "Festivaltickets 2026 – Bespaar op Lowlands, Tomorrowland & Meer",
    subtitle:
      "Bespaar op tickets voor Lowlands, Tomorrowland, Awakenings en meer. Vergelijk en boek via betrouwbare partners.",
    image:
      "https://images.pexels.com/photos/35593189/pexels-photo-35593189.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tableCols: ["Festival", "Locatie", "Datum", "Prijs", "Aanbieder", ""],
    faqs: [
      {
        q: "Zijn festivaltickets persoonsgebonden?",
        a: "Bij sommige festivals zijn tickets op naam gesteld. Controleer altijd de voorwaarden van het festival voordat je koopt.",
      },
      {
        q: "Kan ik een festivalticket doorverkopen?",
        a: "Doorverkoop kan meestal alleen via de officiele doorverkoopkanalen van het festival. Vermijd Marktplaats en social media om fraude te voorkomen.",
      },
      {
        q: "Wanneer start de voorverkoop?",
        a: "De voorverkoop start per festival op een andere datum. Tickets zijn vaak snel uitverkocht, dus zet een herinnering!",
      },
    ],
  },
  vliegtickets: {
    key: "flight",
    eyebrow: "Vliegtickets",
    title: "Goedkope Vliegtickets – Boek Nu en Bespaar!",
    subtitle:
      "Goedkope vliegtickets naar bestemmingen wereldwijd. Vergelijk prijzen en boek eenvoudig via Tix.nl.",
    image:
      "https://images.pexels.com/photos/9129698/pexels-photo-9129698.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tableCols: ["Route", "Vertrek", "Datum", "Prijs", "Aanbieder", ""],
    faqs: [
      {
        q: "Wat is het beste moment om een vliegticket te boeken?",
        a: "Voor binnen-Europese vluchten: 6-8 weken voor vertrek. Voor intercontinentale vluchten: 3-5 maanden voor vertrek.",
      },
      {
        q: "Kan ik mijn vliegticket annuleren?",
        a: "Dit hangt af van het tarief dat je hebt geboekt. Sommige tickets zijn niet annuleerbaar, andere wel tegen een vergoeding.",
      },
      {
        q: "Hoe vind ik de goedkoopste vlucht?",
        a: "Gebruik een vergelijkingswebsite, wees flexibel met data en bestemmingen, en boek op het juiste moment.",
      },
    ],
  },
  attractietickets: {
    key: "attraction",
    eyebrow: "Attractietickets",
    title: "Attractietickets – Koop Nu en Bespaar!",
    subtitle:
      "Tickets voor Disneyland Paris, Efteling, Walibi en meer. Vergelijk prijzen en bespaar op je dagje uit.",
    image:
      "https://images.pexels.com/photos/749061/pexels-photo-749061.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tableCols: ["Attractie", "Locatie", "Type", "Prijs", "Aanbieder", ""],
    faqs: [
      {
        q: "Zijn attractietickets geldig op elke dag?",
        a: "Sommige tickets zijn datumgebonden, andere zijn flexibel inzetbaar. Controleer dit altijd bij de aanbieder.",
      },
      {
        q: "Krijg ik korting bij online boeken?",
        a: "Vaak wel! Online tickets zijn meestal goedkoper dan tickets aan de kassa van het park.",
      },
      {
        q: "Kan ik mijn attractieticket annuleren?",
        a: "De annuleringsvoorwaarden verschillen per park en aanbieder. Lees altijd de voorwaarden voor aankoop.",
      },
    ],
  },
};

export const CATEGORY_CARDS = [
  {
    to: "/concerttickets",
    emoji: "🎤",
    title: "Concerttickets",
    desc: "Vind tickets voor de beste concerten in Nederland en Belgie. Van Armin van Buuren tot Ed Sheeran.",
    image: CATEGORIES.concerttickets.image,
    cta: "Bekijk Concerttickets",
  },
  {
    to: "/festivaltickets",
    emoji: "🎪",
    title: "Festivaltickets",
    desc: "Bespaar op tickets voor Lowlands, Tomorrowland, Awakenings en meer.",
    image: CATEGORIES.festivaltickets.image,
    cta: "Bekijk Festivaltickets",
  },
  {
    to: "/vliegtickets",
    emoji: "✈️",
    title: "Vliegtickets",
    desc: "Goedkope vliegtickets naar bestemmingen wereldwijd. Boek via Tix.nl!",
    image: CATEGORIES.vliegtickets.image,
    cta: "Bekijk Vliegtickets",
  },
  {
    to: "/attractietickets",
    emoji: "🎢",
    title: "Attractietickets",
    desc: "Disneyland Paris, Efteling, Walibi en meer. Bespaar op je dagje uit.",
    image: CATEGORIES.attractietickets.image,
    cta: "Bekijk Attractietickets",
  },
];
